// extracted by mini-css-extract-plugin
export var highlightedSection = "index-module--highlightedSection--3hz3A";
export var services = "index-module--services--OsNxN";